var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 16.668V26.0013M25.9993 26.0013H18.9993C14.5996 26.0013 12.3997 26.0013 11.0329 27.3681C9.66602 28.735 9.66602 30.9349 9.66602 35.3346M25.9993 26.0013H32.9994C37.3991 26.0013 39.599 26.0013 40.9658 27.3681C42.3327 28.735 42.3327 30.9349 42.3327 35.3346M42.3327 35.3346C45.6325 35.3346 47.2824 35.3346 48.3076 36.3598C49.3327 37.3849 49.3327 39.0348 49.3327 42.3346C49.3327 45.6345 49.3327 47.2844 48.3076 48.3095C47.2824 49.3346 45.6325 49.3346 42.3327 49.3346C39.0329 49.3346 37.3829 49.3346 36.3578 48.3095C35.3327 47.2844 35.3327 45.6345 35.3327 42.3346C35.3327 39.0348 35.3327 37.3849 36.3578 36.3598C37.3829 35.3346 39.0329 35.3346 42.3327 35.3346ZM9.66602 35.3346C12.9658 35.3346 14.6158 35.3346 15.6409 36.3598C16.666 37.3849 16.666 39.0348 16.666 42.3346C16.666 45.6345 16.666 47.2844 15.6409 48.3095C14.6158 49.3346 12.9658 49.3346 9.66602 49.3346C6.36618 49.3346 4.71627 49.3346 3.69114 48.3095C2.66602 47.2844 2.66602 45.6345 2.66602 42.3346C2.66602 39.0348 2.66602 37.3849 3.69114 36.3598C4.71627 35.3346 6.36618 35.3346 9.66602 35.3346ZM21.9993 16.668H29.9994C34.8399 16.668 35.3327 14.0781 35.3327 9.66797C35.3327 5.2578 34.8399 2.66797 29.9994 2.66797H21.9993C17.1588 2.66797 16.666 5.2578 16.666 9.66797C16.666 14.0781 17.1588 16.668 21.9993 16.668Z",
    stroke: "#2786BD",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.5d03936d181a723acff4a5a9844e5164.svg";
export { ForwardRef as ReactComponent };